module.exports = __webpack_public_path__ + "img/login-bg.342dbe88.png";